module.exports = __webpack_public_path__ + "static/img/multi-terminal.5a5962c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multi-terminal.png
// module id = 1RS3
// module chunks = 0